import { render } from "./uploadModal.vue?vue&type=template&id=150ae468&scoped=true&lang=pug"
import script from "./uploadModal.vue?vue&type=script&lang=js"
export * from "./uploadModal.vue?vue&type=script&lang=js"

import "./uploadModal.vue?vue&type=style&index=0&id=150ae468&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150ae468"]])

export default __exports__